'use strict';
var alertNotification = require('../components/alertNotification');
/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification (message) {
    alertNotification.set({
        alertName: 'valid-cart-error',
        alertOptions: {
            appendTo: '.cart-error',
            dismissible: true,
            message: message,
            status: 'alert-danger'
        }
    });

    return $('.cart-error').children().last();
}

class GiftBox {
    openModalGiftBox () {
        const btnOpenModal = $('#btnGiftBox');
        const modalGiftBox = $('#giftBoxModal');

        btnOpenModal.on('click', function () {
            modalGiftBox.modal('show');
            modalGiftBox.find('.enter-message').text(modalGiftBox.attr('aria-label'));
            modalGiftBox.find('.close').focus();
        });
    }

    hasMessage () {
        const checkbox = $('#checkboxMessage');
        const message = $('#giftBoxMessage');
        const messageLabel = $('#giftBoxMessageLabel');

        checkbox.on('change', function () {

            if (checkbox.is(':checked')) {
                message.removeClass('d-none');
                messageLabel.removeClass('d-none');
                message.focus();
            } else {
                message.addClass('d-none');
                messageLabel.addClass('d-none');
            }
        });
    }

    addToCart () {
        const btnAddToCart = $('#addToCartGiftBox');
        
        btnAddToCart.on('click', function () {
          
            const isChecked = $('#checkboxMessage').is(':checked');
            const message = isChecked ? $('#giftBoxMessage').val() : '';
            const url = $(this).data('url');

            let payload = {
                productId: btnAddToCart.data('pid'),
            };
            if (isChecked) {
                payload.message = message;
            }

            $.ajax({
                url,
                method: 'POST',
                data: payload,
                success: function (response) {
                    $('#giftBoxModal').modal('hide');
                    if (!response.success) {
                        window.scrollTo({ top: 0, behavior: 'smooth' });

                        var errMsg = createErrorNotification(response.errorMessage);
                        // remove the error message after 5 sec.
                        setTimeout(function () {
                            errMsg.remove();
                        }, 5000);

                        return;
                    }

                    location.reload();

                },
                error: function (err) {
                    if (err.redirectUrl) {
                        window.location.href = err.redirectUrl;
                    } else {
                        createErrorNotification(err.errorMessage);
                        $.spinner().stop();
                    }
                }
            });

        });
    }

    get init () {
        return {
            openModalGiftBox: this.openModalGiftBox(),
            hasMessage: this.hasMessage(),
            addToCart: this.addToCart()
        };
    }
}

const giftBox = new GiftBox;
export default giftBox;
